import { useQuery } from '@tanstack/react-query';
import { useSiflorApi } from '../../providers/SiflorApiProvider/useSiflorApi';

export const useUserTypes = () => {
  const { siflorApi } = useSiflorApi();

  const { data } = useQuery<{
    userType: {
      id: string;
      type: string;
    }[];
  }>({
    queryKey: ['listUserTypes'],
    queryFn: () => {
      return siflorApi.listUserTypes();
    },
  });

  const userTypes = data?.userType || [];

  return { userTypes };
};
